// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import hui from "h_ui";
import "h_ui/dist/h_ui.min.css";
import App from './App'
import router from './router'
import selfMsgBox from '@/components/selfMsgBox'
import http from "@/assets/common/http.js"
import floatFmt from '@/assets/utils/float-fmt';
import moneyFmt from '@/assets/utils/money-fmt'
import dateFmt from '@/assets/utils/date-fmt'
import fundFmt from '@/assets/utils/fund-fmt'
import filters from '@/assets/filters/index.js'
// import Table from '@hui/table'
// import '@hui/table/dist/table.css'
Vue.config.productionTip = false
Vue.use(hui);
// Vue.use(Table)
Vue.prototype.$selfMsgBox = selfMsgBox
Vue.prototype.$http = http

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 特殊数据封装
Vue.prototype.$float = floatFmt;
Vue.prototype.$money = moneyFmt;
Vue.prototype.$date = dateFmt;
Vue.prototype.$fund = fundFmt;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js